import { sanitize } from 'dompurify'
import { suggestionList } from './constants'

const allQueries = suggestionList.map(suggestion => suggestion.searchQuery)
// See more examples at getFilterMatchForQuery tests in src/components/ConversationList/Header/Search/__tests__/util.test.js
const operatorsPattern = `(${allQueries.join('|')})`
const valuePattern = `\\s*\\S*(?!\\S\\s)`
const valueInQuotesPattern = `\\s*(")[^"]*\\4`
export const filterRegex = `(${operatorsPattern}(${valueInQuotesPattern}|${valuePattern}))`
export const createRegexForFilter = filter =>
  new RegExp(`((${filter})(${valueInQuotesPattern}|${valuePattern}))`, 'g')

export const getFilterMatchForQuery = searchQuery => {
  const regex = new RegExp(filterRegex)

  return regex.exec(searchQuery)
}

export const decorateFilterInMenu = text => {
  if (!text || !text.trim()) return ''

  const relaced = text.replace(
    new RegExp(`${filterRegex}`, 'g'),
    `<span class="search-filter">$1</span>`
  )

  return sanitize(relaced, { ALLOWED_TAGS: ['span'] })
}
